import { quickpackApi } from '~/services/api';

import { type DeviceEventRequest } from '../types/deviceEvents.type';

export const postDeviceEvent = async (body: DeviceEventRequest): Promise<void> => {
  await quickpackApi.request<void>({
    data: body,
    method: 'POST',
    url: '/devices/events',
  });
};
